module.exports = __webpack_public_path__ + "img/Multi-account-6.39ad3bb6.png";